export default "__VITE_ASSET__3814afdd__"